<template>
  <section id="why-tunnelbear" class="bg-light">
    <div class="section-inner">
    <h2 class="text-center">Why use TunnelBear</h2>
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <img-text img="open.png"
                      imgWidth="100"
                      title="Open"
                      txt="Change your device’s location to access websites, services, and apps that are blocked in your country.">
            </img-text>
          </div>
          <div class="col-xs-12 col-md-4">
            <img-text img="private.png"
                      imgWidth="100"
                      title="Private"
                      txt="Keep your browsing and physical location private from hackers, ISPs and third parties.">
            </img-text>
          </div>
          <div class="col-xs-12 col-md-4">
            <img-text img="secure.png"
                      imgWidth="100"
                      title="Secure"
                      txt="Get peace of mind when you’re working, shopping, or banking online.">
            </img-text>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <img-text img="lightning.png"
                      imgWidth="100"
                      title="Lightning Fast"
                      txt="Get lightning fast speeds with TunnelBear's award winning service.">
            </img-text>
          </div>
          <div class="col-xs-12 col-md-4">
            <img-text img="logging.png"
                      imgWidth="100"
                      title="No Logging"
                      txt="TunnelBear does NOT log activity of users connected to our service. Period.">
            </img-text>
          </div>
          <div class="col-xs-12 col-md-4">
            <img-text img="trusted.png"
                      imgWidth="100"
                      title="Trusted"
                      txt="We have earned the respect of over 21 million people around the world.">
            </img-text>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import imgTxt from '@/components/img-text/img-text'

export default {
  name: 'why-tunnelbear',
  data () {
    return {}
  },
  components: {
    'img-text': imgTxt
  }
}
</script>

<style scoped lang="stylus" src="./why-tunnelbear.styl">
